import React from 'react'
import { ProgressBar } from './Styled/Picker'
function WeekEndMessage() {
  return (
    <ProgressBar>
      <div>Pick next week!</div>
    </ProgressBar>
  )
}

export default WeekEndMessage
